// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!./MapButtons.module.css");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../assets/images/button_icons/refresh.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Aq4b7gxd0haHo18EdfHd {
    --icon-background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    --icon-background-size: 21px;
    transition: opacity 0.3s ease !important;
}

.yeDN6LZz3jab1uj1JOFt {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
  pointer-events: none !important;
}`, "",{"version":3,"sources":["webpack://./../core/components/map-buttons/RefreshMapButton.module.css"],"names":[],"mappings":"AAAA;IAEI,gEAAgE;IAChE,4BAA4B;IAC5B,wCAAwC;AAC5C;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;AACjC","sourcesContent":[".refreshMapIcon {\r\n    composes: mapButtonIcon from './MapButtons.module.css';\r\n    --icon-background-image: url('@images/button_icons/refresh.svg');\r\n    --icon-background-size: 21px;\r\n    transition: opacity 0.3s ease !important;\r\n}\r\n\r\n.coolingDown {\r\n  opacity: 0.5 !important;\r\n  cursor: not-allowed !important;\r\n  pointer-events: none !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"refreshMapIcon": `Aq4b7gxd0haHo18EdfHd ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mapButtonIcon"]}`,
	"coolingDown": `yeDN6LZz3jab1uj1JOFt`
};
module.exports = ___CSS_LOADER_EXPORT___;
